module.exports = __webpack_public_path__ + "img/m3.2cfc80f8.png";